export default {
  colors: {
    cream: '#FFF0D7',
    pink: '#F26D65',
    navy: '#004564',
    teal: '#009E9B',
    aqua: '#8DD1C3',

  },
  breakpoints: {
    large: '1024',
    extraLarge: '1600px'
  }
}